const frequencies = [
  {
    id: 1,
    name: 'Día(s)'
  },

  {
    id: 2,
    name: 'Semana(s)'
  },

  {
    id: 3,
    name: 'Mes(es)'
  },

  {
    id: 4,
    name: 'Año(s)'
  }
]

export default frequencies
